import styles from './index.module.scss';
import { useTranslation } from 'react-i18next';

const PrivacyPolicy = () => {
      const { t, i18n } = useTranslation();
    return (
        <div className={styles['PrivacyPolicy']}>
            <h1>{t('PrivacyPolicy.Statement')}</h1>
            <p>{t('PrivacyPolicy.Statementdescription')}</p>
            <h2>{t('PrivacyPolicy.appliesto')}</h2>
            <p>{t('PrivacyPolicy.appliestodescription')}</p>
            <h2>{t('PrivacyPolicy.notappliesto')}</h2>
            <p>{t('PrivacyPolicy.notappliestodescription')}</p>
            <h2>{t('PrivacyPolicy.Changesto')}</h2>
            <p>{t('PrivacyPolicy.Changestodescription')}</p>
            <h2>{t('PrivacyPolicy.Browsingwebsites')}</h2>
            <p>{t('PrivacyPolicy.Browsingwebsitesdescription')}</p>
            <h2>{t('PrivacyPolicy.userprofile')}</h2>
            <p>{t('PrivacyPolicy.userprofiledescription')}

            </p>
            <ul>
                <li>{t('PrivacyPolicy.allow1')}</li>
                <li>{t('PrivacyPolicy.allow2')}</li>
                <li>{t('PrivacyPolicy.allow3')}</li>
                <li>{t('PrivacyPolicy.allow4')}</li>
                <li>{t('PrivacyPolicy.allow5')}</li>
            </ul>
            <h2>{t('PrivacyPolicy.Intelligence')}</h2>
            <p>{t('PrivacyPolicy.Intelligencedescription')}</p>
            <h2>{t('PrivacyPolicy.registration')}</h2>
            <p>{t('PrivacyPolicy.registrationdescription')}</p>
            <h2>{t('PrivacyPolicy.Retail')}</h2>
            <p>{t('PrivacyPolicy.Retaildescription')}</p>
            <h2>{t('PrivacyPolicy.Customerservice')}</h2>
            <p>{t('PrivacyPolicy.Customerservicedescription')}</p>
            <h2>{t('PrivacyPolicy.Marketing')}</h2>
            <p>{t('PrivacyPolicy.Marketingdescription')}</p>
            <h2>{t('PrivacyPolicy.Loyalty')}</h2>
            <p>{t('PrivacyPolicy.Loyaltydescription')}</p>
            <h2>{t('PrivacyPolicy.media')}</h2>
            <p>{t('PrivacyPolicy.mediadescription')}</p>
            <h2>{t('PrivacyPolicy.forums')}</h2>
            <p>{t('PrivacyPolicy.forumsdescription')}</p>
            <h2>{t('PrivacyPolicy.Testimonials')}</h2>
            <p>{t('PrivacyPolicy.Testimonialsdescription')}</p>
            <h2>{t('PrivacyPolicy.Employment')}</h2>
            <p>{t('PrivacyPolicy.Employmentdescription')}</p>
            <h2>{t('PrivacyPolicy.relationships')}</h2>
            <p>{t('PrivacyPolicy.relationshipsdescription')}</p>
            <h2>{t('PrivacyPolicy.administration')}</h2>
            <p>{t('PrivacyPolicy.administrationdescription')}</p>
            <h2>{t('PrivacyPolicy.Mergers')}</h2>
            <p>{t('PrivacyPolicy.Mergersdescription')}</p>
            <h2>{t('PrivacyPolicy.Disclosure')}</h2>
            <p>{t('PrivacyPolicy.Disclosuredescription')}</p>
            <h2>{t('PrivacyPolicy.requirements')}</h2>
            <p>{t('PrivacyPolicy.requirementsdescription')}</p>
            <h2>{t('PrivacyPolicy.advertising')}</h2>
            <p>{t('PrivacyPolicy.advertisingdescription')}
                <ul>
                    <li>{t('PrivacyPolicy.purposes1')}</li>
                    <li>{t('PrivacyPolicy.purposes2')}</li>
                    <li>{t('PrivacyPolicy.purposes3')}</li>
                    <li>{t('PrivacyPolicy.purposes4')}</li>
                </ul>
                {t('PrivacyPolicy.determine')}
                <ul>
                    <li>{t('PrivacyPolicy.cookies1')}</li>
                    <li>{t('PrivacyPolicy.cookies2')}</li>
                    <li>{t('PrivacyPolicy.cookies3')}</li>
                    <li>{t('PrivacyPolicy.cookies4')}</li>
                    <li>{t('PrivacyPolicy.cookies5')}</li>
                    <li>{t('PrivacyPolicy.cookies6')}</li>
                    <li>{t('PrivacyPolicy.cookies7')}</li>
                    <li>{t('PrivacyPolicy.cookies8')}</li>
                    <li>{t('PrivacyPolicy.cookies9')}</li>
                    <li>{t('PrivacyPolicy.cookies10')}</li>
                    <li>{t('PrivacyPolicy.cookies11')}</li>
                    <li>{t('PrivacyPolicy.cookies12')}</li>
                    <li>{t('PrivacyPolicy.cookies13')}</li>
                </ul>
                {t('PrivacyPolicy.Analytics')}
            </p>
            <h2>{t('PrivacyPolicy.Objects')}</h2>
            <p>{t('PrivacyPolicy.Objectsdescription')}</p>
            <h2>{t('PrivacyPolicy.beacons')}</h2>
            <p>{t('PrivacyPolicy.beaconsdescription')}</p>
            <h2>{t('PrivacyPolicy.URL')}</h2>
            <p>{t('PrivacyPolicy.URLdescription')}
                <ul>
                    <li>{t('PrivacyPolicy.information1')}</li>
                    <li>{t('PrivacyPolicy.information2')}</li>
                    <li>{t('PrivacyPolicy.information3')}</li>
                    <li>{t('PrivacyPolicy.information4')}</li>
                </ul>
                {t('PrivacyPolicy.categories')}
            </p>
            <h2>{t('PrivacyPolicy.FAQs')}</h2>
            <p>{t('PrivacyPolicy.FAQsdescription1')}</p>
            <p>{t('PrivacyPolicy.FAQsdescription2')}
                <ul>
                    <li>{t('PrivacyPolicy.apply1')}</li>
                    <li>{t('PrivacyPolicy.apply2')}</li>
                    <li>{t('PrivacyPolicy.apply3')}</li>
                    <li>{t('PrivacyPolicy.apply4')}</li>
                    <li>{t('PrivacyPolicy.apply5')}</li>
                </ul>
                <p>{t('PrivacyPolicy.protected')}</p>
                <p>{t('PrivacyPolicy.technical')}</p>
            </p>
            <p>{t('PrivacyPolicy.protection')}</p>
            <p>{t('PrivacyPolicy.Applicable')}
                <ul>
                    <li>{t('PrivacyPolicy.rightto1')}</li>
                    <li>{t('PrivacyPolicy.rightto2')}</li>
                    <li>{t('PrivacyPolicy.rightto3')}</li>
                    <li>{t('PrivacyPolicy.rightto4')}</li>
                    <li>{t('PrivacyPolicy.rightto5')}</li>
                </ul>
                {t('PrivacyPolicy.personal')}
            </p>
            <p>{t('PrivacyPolicy.Program')}</p>
            <p>{t('PrivacyPolicy.exercise')}
                <ul>
                    <li>{t('PrivacyPolicy.States')}</li>
                </ul>
            </p>
            <p>{t('PrivacyPolicy.Additional')}</p>
        </div>
    );
}

export default PrivacyPolicy;